import { CompareByTimePreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/CompareByTimePreview';
import {
  useGetFormattedDurationFieldLabels,
  useGetQuantifyCompareQuery,
  useGetQuantifyDuration,
  useIsDashboardDurationApplied,
} from '@modules/quantify/hooks';
import { Stack, Typography } from '@mui/material';

export function DurationPreview() {
  const duration = useGetQuantifyDuration();
  const compareQuery = useGetQuantifyCompareQuery();
  const { durationLabel } = useGetFormattedDurationFieldLabels();
  const isDashboardDurationApplied = useIsDashboardDurationApplied();

  if (!!compareQuery?.timerange || !!compareQuery?.previousPeriod) {
    return <CompareByTimePreview />;
  }

  return (
    <Stack>
      <Typography variant="subtitle1">Duration:</Typography>
      <Typography
        variant="body2"
        color={isDashboardDurationApplied ? 'info.main' : 'primary.main'}
      >
        {durationLabel.primary}
      </Typography>
      {duration.type === 'last' ? (
        <Typography
          variant="caption"
          color={isDashboardDurationApplied ? 'info.main' : 'primary.main'}
        >
          {durationLabel.secondary}
        </Typography>
      ) : null}
    </Stack>
  );
}
